module.exports = __webpack_public_path__ + "static/img/成功案例详情页.74895487.png";